import { Text, TextSkeleton } from "@src/appV2/redesign/system/ui-components";

interface ShiftQualificationLabelProps {
  qualificationText: string;
  variant?: "body1" | "body2";
  isLoading?: boolean;
}

/**
 * Displays shift qualification information with loading state support.
 * Shows required qualifications in secondary text color.
 */
export function ShiftQualificationLabel(props: ShiftQualificationLabelProps) {
  const { qualificationText, variant = "body2", isLoading } = props;

  if (isLoading) {
    return <TextSkeleton width="2rem" variant={variant} />;
  }

  return (
    <Text
      variant={variant}
      sx={(theme) => ({
        width: "fit-content",
        color: theme.palette.text.secondary,
      })}
    >
      {qualificationText}
    </Text>
  );
}
